module.exports = "https://www.gc-qa.gnp.com.mx/eec100a35597f8b7a6407aada97ec818.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/verified_user_success.svg
// module id = 157
// module chunks = 0